/**
 * Routes
 */
/* eslint-disable */
import { WhatsNumbersList } from 'components/AsyncComponent';
import { Layout, Section } from 'layout';
import { Redirect, Route, Switch } from 'react-router-dom';

const Forms = ({ match }) => {
  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
          <Route path={`${match.url}/list`} component={WhatsNumbersList} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default Forms;
